<template>
    <div class="learn-more" v-if="result.costRating || result.qualityRating">
      <hp5-link-text-basic :data-card-rank="rank" size="xs" href="/fcp/cost-and-quality/" text="Learn more about ratings" target="_blank" />
    </div>
  </template>
  <script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

  </script>